import * as React from 'react';
import type { ConnectFieldsApi, ConnectFieldContextProp } from '../connect-fields-provider';
import { ConnectFieldContext } from '../connect-fields-provider';

interface FormInput {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	[fieldName: string]: any;
}

export interface InjectedConnectFieldsSupportProps {
	onSubmit?: (formInput: FormInput) => Promise<FormInput> | FormInput | void;
	portalId?: number;
	requestTypeId?: number;
	projectId?: string;
	xsrfToken?: string;
}

const withConnectFieldSupport = <TProps extends InjectedConnectFieldsSupportProps>(
	options: React.ComponentType<TProps>,
) => {
	return class ConnectFieldSupport extends React.PureComponent<TProps> {
		connectFieldApi: ConnectFieldsApi | null;

		onConnectFieldMount = (el: ConnectFieldsApi | null) => {
			this.connectFieldApi = el;
		};

		contextValue: ConnectFieldContextProp = {
			onConnectFieldMount: this.onConnectFieldMount,
		};

		onSubmit = async () => {
			const { portalId, requestTypeId, projectId, xsrfToken } = this.props;

			if (this.connectFieldApi && portalId && requestTypeId && projectId && xsrfToken) {
				return Promise.resolve(this.connectFieldApi.validate(requestTypeId))
					.then((allConnectFieldValid) => {
						if (!this.connectFieldApi) {
							throw new Error('connect field unavailable');
						}
						const validatedItems = allConnectFieldValid.filter(
							(validationResult) => !validationResult.timedOut,
						);
						if (validatedItems.every((validationResult) => Boolean(validationResult.valid))) {
							const validConnectKeys = validatedItems.map(
								(validationResult) => validationResult.connectKey,
							);
							return this.connectFieldApi.serialize(validConnectKeys, requestTypeId);
						}
						throw new Error('validation failed');
					})
					.then((data) => {
						return data;
					})
					.catch((e) => {
						throw e;
					});
			}
			return [];
		};

		render() {
			const Child = options;
			return (
				<ConnectFieldContext.Provider value={this.contextValue}>
					<Child {...this.props} onSubmit={this.onSubmit} />
				</ConnectFieldContext.Provider>
			);
		}
	};
};

export default withConnectFieldSupport;
